import type { HeaderContext, SortDirection } from '@tanstack/react-table';
import { DataGridColumnHeader } from '../components/grid/data-grid-column-header';
import type { DataGridColumnDef } from '../data-grid.type';
import { ESortDirection, OrderByEnum } from '../data-grid.type';

export function getColumnDefCustomHeader<T>(col: DataGridColumnDef<T>) {
	if (!col.customHeader) {
		throw new Error('Column must have a customHeader defined');
	}

	return col.customHeader;
}

export function getColumnDefDefaultHeader<T>(col: DataGridColumnDef<T>) {
	return function DefaultHeader({ column }: HeaderContext<T, unknown>) {
		return <DataGridColumnHeader column={column} title={col.header || col.key} />;
	};
}

export function getColumnDefHeader<T>(col: DataGridColumnDef<T>) {
	// Use custom header if provided
	if (col.customHeader) {
		return getColumnDefCustomHeader(col);
	}

	// Otherwise use default header
	return getColumnDefDefaultHeader(col);
}

/**
 * Converts the tanstack column sort direction to our enum
 * @param columnSort The column sort direction from Tanstack Table
 * @returns The column sort direction as an enum
 */
export function tanstackColumnSortedToEnumSort(columnSort: SortDirection | false): OrderByEnum {
	return columnSort === ESortDirection.ASC ? OrderByEnum.ASC : OrderByEnum.DESC;
}
